import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'followedPropertyFilter',
})
export class FollowedPropertyFilterPipe implements PipeTransform {
  filteredResult = [];
  transform(value: any, args?: any): any {
    if (args && value) {
      this.filteredResult = [];
      const tempArray = JSON.parse(JSON.stringify(value));
      tempArray.filter((el, index) => {
        if (
          (el.name && el.name.toString().toLowerCase().includes(args.toLowerCase())) ||
          (el.Address && el.Address.toLowerCase().includes(args.toLowerCase()))
        ) {
          this.filteredResult.push(value[index]);
        }
      });
      return this.filteredResult;
    } else {
      return value;
    }
  }
}
